
import { Component, Prop, Vue } from "vue-property-decorator";
import { getPermission, setPermission } from "@/api/api-basic";
import { objAny } from "@/common/common-interface";
import i18n from "@/config/i18n";
@Component
export default class PermissionMenu extends Vue {
  @Prop({
    default: () => {
      return [];
    },
    type: Array
  })
  private roleTypeList!: object[];
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  private privilege!: objAny;
  private tableList: object[] = [];
  private itemData: objAny = {};
  private loading = false;
  private setLoading = false;
  private allChecked = false;

  private formInline: objAny = {
    roleId: ""
  };
  private tableColumns: object[] = [
    {
      title: i18n.t("role.moduleName"),
      key: "moduleName",
      // slot: "moduleName",
      minWidth: 240,
      maxWidth: 400,
      tree: true
    },
    {
      title: i18n.t("role.checkRender"),
      key: "checkRender",
      minWidth: 500,
      slot: "checkRender"
    }
  ];
  mounted(): void {
    if (this.$i18n.locale == "en-US") {
      const obj: objAny = this.tableColumns[0];
      obj["key"] = "englishName";
    } else if (this.$i18n.locale == "zh-CN") {
      const obj: objAny = this.tableColumns[0];
      obj["key"] = "moduleName";
    } else {
      const obj: objAny = this.tableColumns[0];
      obj["key"] = "thailandName";
    }
  }
  public checkboxChange(val: boolean, data: objAny) {
    const key = data.column.key;
    const row = data.row;

    const isAll = data.modulePkId == "-1" ? true : false;
    this.forTableList(this.tableList, row.modulePkId, key, val, isAll);
  }
  public checkChange(val: boolean, data: objAny, item: objAny) {
    const key = item.privilegeCode;
    const isAll = false;
    this.forTableList(this.tableList, data.modulePkId, key, val, isAll);
  }

  public allChange() {
    this.tableList = this.allTableList(this.tableList);
  }
  public allTableList(list: object[]): object[] {
    list.map((item: objAny) => {
      if (item.privilegeVoList && item.privilegeVoList.length > 0) {
        item.privilegeVoList.map((child: objAny) => {
          child.checked = this.allChecked;
        });
      }
      if (item.children && item.children.length > 0) {
        item.children = this.allTableList(item.children);
      }
    });
    return list;
  }
  public forTableList(
    list: object[],
    id: string,
    key: string,
    value: boolean,
    isAll: boolean
  ): object[] {
    // 把选择中 child 那一列勾上
    list.map((item: objAny) => {
      if (item.modulePkId == id || isAll) {
        // 找到点击的那一行
        if (item.privilegeVoList) {
          item.privilegeVoList.map((vo: objAny) => {
            if (vo.privilegeCode === key) {
              vo.checked = value;
            }

            if (
              key !== "100501" &&
              vo.privilegeCode == "100501" &&
              !vo.checked &&
              value
            ) {
              // 如果选择了不是浏览的并没有选择浏览，就把浏览勾上
              vo.checked = true;
            }
          });
        }
        if (item.children && item.children.length > 0) {
          item.children = this.forTableList(
            item.children,
            id,
            key,
            value,
            true
          );
        }
      } else {
        if (item.children && item.children.length > 0) {
          item.children = this.forTableList(
            item.children,
            id,
            key,
            value,
            isAll
          );
        }
      }
    });
    return list;
  }
  public init(data: objAny): void {
    this.itemData = data;
    this.formInline.roleId = data.rolePkId;
    this.formInline.roleType = data.roleType + "";
    this.getPermission();
  }

  async getPermission(): Promise<void> {
    this.loading = true;
    let json: objAny = {};
    if (this.formInline.roleId == "") {
      json["beTemplate"] = true;
    } else {
      json = JSON.parse(JSON.stringify(this.formInline));
    }
    const ret = await getPermission(json);

    if (ret.status === this.$config.apiStatus) {
      if (ret.data.length > 0) {
        const list: objAny[] = [];

        ret.data.map((item: objAny, index: number) => {
          // if (index == 0) {
          //   console.log(item);
          //   item.fristChild = true;
          // }
          if (
            this.formInline.roleType == 2 ||
            this.formInline.roleType == 3 ||
            this.formInline.roleType == 6
          ) {
            if (item.modulePkId == 2) {
              list.push(item);
            }
          } else if (this.formInline.roleType == item.modulePkId) {
            list.push(item);
          }
          item._showChildren = true;
        });
        list[0].fristChild = true;
        this.tableList = list;
      } else {
        this.tableList = [];
      }
    }
    this.loading = false;
  }
  public forSubTableLsit(children: object[]): object[] {
    const arr: object[] = [];
    children.map((item: objAny) => {
      const subsystemPkId = item.subsystemPkId
        ? item.subsystemPkId
        : item.modulePkId;
      const obj: objAny = {
        subsystemPkId: subsystemPkId,
        modulePkId: item.modulePkId
      };
      if (item.children) {
        obj["children"] = this.forSubTableLsit(item.children);
      }
      if (item.privilegeVoList) {
        const privilegeVoList: object[] = [];
        item.privilegeVoList.map((voList: objAny) => {
          privilegeVoList.push({
            checked: voList.checked,
            privilegeCode: voList.privilegeCode
          });
        });
        obj["privilegeVoList"] = privilegeVoList;
      }
      arr.push(obj);
    });
    return arr;
  }

  async setPermission(): Promise<void> {
    this.setLoading = true;
    const tableList = JSON.parse(JSON.stringify(this.tableList));
    const json = {
      roleId: this.formInline.roleId,
      permissionParams: this.forSubTableLsit(tableList)
    };
    const ret = await setPermission(json);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      // this.getPermission();
      this.$emit("success");
    }
    this.setLoading = false;
  }
}
